/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type SearchCustomersV2QueryVariables = Types.Exact<{
  maxResults: Types.Scalars['Int']['input']
  searchTerm: Types.Scalars['String']['input']
  tenant: Types.Scalars['String']['input']
}>

export type SearchCustomersV2Query = {
  __typename?: 'Query'
  searchCustomersV2: {
    __typename?: 'SearchCustomersResult'
    total: number
    customers: Array<{
      __typename?: 'FoundCustomer'
      id: string
      email: string | null
      givenName: string | null
      familyName: string | null
      phoneNumber: string | null
      customerTenant: string
    }>
  }
}

export const SearchCustomersV2Document = gql`
    query searchCustomersV2($maxResults: Int!, $searchTerm: String!, $tenant: String!) {
  searchCustomersV2(
    maxResults: $maxResults
    searchTerm: $searchTerm
    tenant: $tenant
  ) {
    total
    customers {
      id
      email
      givenName
      familyName
      phoneNumber
      customerTenant
    }
  }
}
    `

/**
 * __useSearchCustomersV2Query__
 *
 * To run a query within a React component, call `useSearchCustomersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersV2Query({
 *   variables: {
 *      maxResults: // value for 'maxResults'
 *      searchTerm: // value for 'searchTerm'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useSearchCustomersV2Query(
  baseOptions: Apollo.QueryHookOptions<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  > &
    (
      | { variables: SearchCustomersV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  >(SearchCustomersV2Document, options)
}
export function useSearchCustomersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  >(SearchCustomersV2Document, options)
}
// @ts-ignore
export function useSearchCustomersV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchCustomersV2Query,
  SearchCustomersV2QueryVariables
>
export function useSearchCustomersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchCustomersV2Query,
        SearchCustomersV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchCustomersV2Query | undefined,
  SearchCustomersV2QueryVariables
>
export function useSearchCustomersV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchCustomersV2Query,
        SearchCustomersV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SearchCustomersV2Query,
    SearchCustomersV2QueryVariables
  >(SearchCustomersV2Document, options)
}
export type SearchCustomersV2QueryHookResult = ReturnType<
  typeof useSearchCustomersV2Query
>
export type SearchCustomersV2LazyQueryHookResult = ReturnType<
  typeof useSearchCustomersV2LazyQuery
>
export type SearchCustomersV2SuspenseQueryHookResult = ReturnType<
  typeof useSearchCustomersV2SuspenseQuery
>
export type SearchCustomersV2QueryResult = Apollo.QueryResult<
  SearchCustomersV2Query,
  SearchCustomersV2QueryVariables
>
